var _style, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrustLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tucen_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1028 1028",
    style: {
      enableBackground: "new 0 0 1028 1028"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F08727;}\n\t.st2{fill:#191919;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ziyuan 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 514,
    cy: 514,
    r: 514
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.1,325.2l283.2-163.5c9.8-5.6,21.8-5.6,31.5,0l178.4,103c15.1,8.7,20.3,28,11.6,43.1 c-1.4,2.4-3,4.5-4.9,6.5L706.3,375c-10.1,10.1-25.7,12.2-38.1,5.1l-86.1-49.7c-10-5.7-22.2-5.7-32.2,0L251.4,504.5v-152 C251.4,341.3,257.4,330.8,267.1,325.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M760.9,762.9L581.8,866.3c-9.7,5.6-21.8,5.6-31.5,0L267.1,702.8c-9.8-5.6-15.8-16-15.8-27.3V537.6l146-84.6 v138.2c0,11.3,6,21.7,15.8,27.3l137.3,79.2c9.7,5.6,21.8,5.6,31.5,0l86.9-50.1c12.4-7.1,28-5.1,38,5l60.6,60.7 c12.3,12.3,12.3,32.3,0,44.6C765.5,759.9,763.3,761.5,760.9,762.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrustLogo);
export default __webpack_public_path__ + "static/media/crust-logo.6926cea805ce87c9bb020ffde299c7bd.svg";
export { ForwardRef as ReactComponent };